<template>
    <v-autocomplete
        ref="toSpecField"
        v-model="specField"
        :disabled="!to.filter.doc"
        clearable
        color="teal"
        label="Specialization"
        :items="getToSpecs"
        item-text="sp_name"
        auto-select-first
        autocomplete="nope"
        return-object
        @change="handleChangeSpecField($event)"
    />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['to'],
    data: ()=>({
        specField: null
    }),
    computed: {
        ...mapGetters(['getToSpecs'])
    },
    watch: {
        getToSpecs(newVal) {
            if (newVal) this.specField = newVal[0]
        },
        'to.specField': {
            handler(newVal) {
                this.specField = newVal
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        ...mapActions(['toDoctors']),
        handleChangeSpecField(value) {
            this.to.specField = value
            this.to.hospClinDoctorCode = null
            this.to.hospClinDoctor = ''
            this.to.hospClinType = 'H'
            this.to.decking = ''
            if (this.to.facility)
                this.toDoctors({ PTYPE: '', HOSP_MSU: this.to.facility && this.to.facility.hosp_msu_code, SPEC: value && value.sp_desc })
        }
    }
}
</script>
